var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.comment},[_c('div',{class:_vm._.hd,on:{"click":_vm.handleMoreClick}},[_c('div',{class:_vm._.title},[_vm._v("评价(0)")])])])}
var staticRenderFns = []

export { render, staticRenderFns }